module.exports = __webpack_public_path__ + "img/026.3be8c857.jpg";